@import '../../../../../constants/spacing.module.less';

.page-description {
  line-height: 1.5;
  margin-bottom: @space-12;
}

.header-tooltip {
  display: inline-block;
  margin-left: 1px;

  .header-icon {
    height: 16px;
  }
}
